// extracted by mini-css-extract-plugin
export default {"videoContainer":"index_videoContainer_RyOSx","containerMargin":"index_containerMargin_KuCvP"};